enum SensorWorkStatus {
  PAIRED = "paired",
  NOT_PAIRED = "not_paired",
}

export default SensorWorkStatus
